import { EMPTY_LIST } from '../../../constants/common'
import { FORMIK_EMPTY_VALUE } from '../../../constants/validation'

export const LABEL_FORM_FIELD_NAME_TITLE = 'name'

export const LABEL_FORM_FIELD_NAME_COLOR = 'color'

export const LABEL_FORM_FIELD_NAME_ENTITY = 'entity'

export const LABEL_FIELD_NAME_PRIVACY = 'privacy'

export const INITIAL_VALUES = {
  [LABEL_FIELD_NAME_PRIVACY]: null,
  [LABEL_FORM_FIELD_NAME_COLOR]: FORMIK_EMPTY_VALUE,
  [LABEL_FORM_FIELD_NAME_ENTITY]: EMPTY_LIST,
  [LABEL_FORM_FIELD_NAME_TITLE]: FORMIK_EMPTY_VALUE,
}

export const LABEL_FORM_FIELD_TITLE_MAX_LENGTH = 100

export const QA_NAME_LABEL_DELETE_BTN = 'deleteLabel'
